//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { addServerPath } from "../../plugins/add-server-path.js";

export default {
  name: "IconView",
  props: {
    /** @typedef {"picto_white" | "picto_black" | "picto_328fe5"} */
    color: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      default: ''
    },
    pathNoColor: {
      type: String,
      default: ''
    },
    pathValid: {
      type: Boolean
    },
    cover: {
      type: Boolean
    },
    circle: {
      type: Boolean
    },
    center: {
      type: Boolean
    },
    icon: {
      type: String,
      default: ''
    },
    showWhiteBackground: {
      type: Boolean,
      default: true
    },
    notLazy: {
      type: Boolean,
      default: false
    },
    isLocal: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    imageUrl() {
      if (this.icon) {
        return `/admin/icon_files/${this.icon}/${this.color}/`
      }
      if (this.pathValid) {
        if (this.pathNoColor) return this.pathNoColor
        return `${this.path}${this.color}/`
      }
      return null
    },
    imageLocalUrl() {
      if (this.icon) {
        try {
          return require(`~/assets/img/icon_files/${this.icon}`)
        }
        catch(e){
          return null;
        }
      }

      return null
    },
    checkLocal(){
      return !!this.isLocal;
    }
  },
  methods: {
    addServerPath: addServerPath,
  }
}
